import "./FreeTrialContact.module.css";
import Header from "@/reusable_sections/Header";
import Trial from "./sections/Trial";
import AdmissionsProcess from "./sections/AdmissionsProcess";
import Footer from "@/reusable_sections/Footer";
export default function FreeTrialContactPage() {
  return <div>
      <Header />
      <AdmissionsProcess />
      <Trial />
      <Footer />
    </div>;
}